'use strict';

var $   = require('jquery');
var get = require('lodash.get');


/*eslint-disable */
function adManagerFactory() {
    var $dartAds = $('.dart-ad');
    var totalAds = $dartAds.length;
    var slotsToRefreshInVideoChange = [];
    var isSlideshow;
    // Check for adblocker here
    $(window).trigger('fc:adsbeforeload');

    var adsLoaded = [];
    var DEBUG = 1;
    var adlog = function () {
        if (DEBUG) {
            // console.log.apply(console, arguments);
        }
    };

    window.__mtm_data = window.__mtm_data || [];

    // STANDARD AD MARKUP:
    // <div class='ad-wrapper'>
    // <div id='header-imu' class='header-ad ad-unit' data-advertising='imu_1'>
    //     <div class='dart-ad'></div>
    // </div>
    // </div>

    // list of adsizes, if other ad things need different sizes need different names or something

    // RESPONSE SCREEN SIZE WIDTHS
    // Large: width >=1024
    // Medium:  width >= 640
    // Small: width < 640

    var RESPONSIVE_AD_SIZES = {
        welcome: [
            [[1024, 0],
                [[600, 600], [640, 480], [600, 400]]],
            [[640, 0],
                [[600, 600], [640, 480], [600, 400]]],
            [[0, 0],
                [[320, 250], [300, 250]]]
        ],
        flexiblepushdown: [
            [[1024, 0],
                [[970, 90], [970, 250], [728, 90], [2, 2]]]
        ],
        flexiblehalfpage: [
            [[1024, 0],
                [[300, 600], [300, 250]]]
        ],
        fixedrectangle: [
            [[1024, 0],
                [[300, 250]]],
            [[640, 0],
                [[300, 250]]]
        ],
        slideshowrectangle: [
            [[1024, 0],
                [[300, 250]]],
            [[640, 0],
                [[300, 250]]],
            [[0, 0],
                [[300, 250]]]
        ],
        mobilerectangle: [
            [[0, 0],
                [[640,1138], [320, 250], [300, 250], [2, 2]]]
        ],
        mobileleaderboard: [
            [[0, 0],
                [[320, 50], [320, 100], [2, 2]]]
        ],
        flexibleleaderboard: [
            [[640, 0],
                [[728, 90], [2, 2]]]
        ],
        flexibleinterrupter: [
            [[1024, 0],
                [[970, 250], [970, 600], [728, 90], [2, 2]]]
        ],
        flexiblelogo: [
            [[0, 0],
                [[120, 90], [120, 60], [88, 31]]]
        ],
        flexibleportrait: [
            [[1024, 0],
                [[300, 1050], [300, 600], [300, 250]]]
        ],
        oop: [
            [[0, 0],
                [[1, 1]]]
        ]
    };

    var ADSIZES = {
        mobile_banner: [
            [320, 50]
        ],
        mobile_imu: [
            [300, 250]
        ],
        mobile_interstitial: [
            [320, 250]
        ],
        standard_leaderboard: [
            [720, 90]
        ],
        wide_leaderboard: [
            [970, 90]
        ],
        large_leaderboard: [
            [970, 250]
        ],
        xlarge_leaderboard: [
            [970, 415]
        ],
        standard_imu: [
            [300, 250]
        ],
        tall_imu: [
            [300, 600]
        ],
        xtall_imu: [
            [300, 1050]
        ],
        // OLD NAMES, FOR TESTING:
        flexleaderboard: [
            [970, 90],
            [970, 66],
            [970, 60],
            [728, 90],
            [970, 250],
            [320, 50]
        ],
        imu_1: [
            [300, 600],
            [300, 250]
        ],
        imu_2: [
            [300, 600],
            [300, 250]
            // [300, 1050]
        ],
        imu_3: [
            [300, 249]
        ],
        imu_4: [
            [300, 250]
        ],
        interstitial: [
            [574, 374],
            [550, 480],
            [300, 250]
        ],
        logo: [
            [120, 90],
            [120, 60],
            [88, 31]
        ],
        leaderboard: [
            [728, 90]
        ],
        editinjection: [
            [618, 250],
            [1, 2]
        ],
        portrait: [
            [300, 1050]
        ],
        welcome_splash: [
            [600, 600],
            [600, 400],
            [640, 480],
            [320, 250]
        ]
    };

    // Ad to be hidden on first user event
    var USER_EVENT_REFRESH_AD_HIDE = 'flexibleportrait';
    // Ads to show and refresh on user event
    var USER_EVENT_REFRESH_AD = 'slideshowrectangle';
    // The debounce period to avoid over-refreshing
    var USER_EVENT_REFRESH_DEBOUNCE_PERIOD = 4000;
    // The number of user events to trigger refreshing
    var USER_EVENT_REFRESH_COUNT = 3;

    var WAITTIME = 2000; // two seconds

    var REFRESH_THESE = []; // an array of adslots to refresh all at once

    // for IE8
    function dateNow() {
        return +new Date();
    }

    var AdSlot = function (base, name, $container) {
        this.$block = $container;
        this.base_path = base;
        this.slot = null;
        this.name = name;
        this.lastTime = 0;
        this.spotid = uniqueId('id-ad-slot-' + name + '-');
        this.supertag_override = $container.data('supertag');

        return this._buildAd($container);

    };

    AdSlot.prototype = {
        _buildAd: function ($block) {
            adlog('Building ad ' + this.spotid);
            this.$spot = $block.find('.dart-ad');
            this.$spot.attr('id', this.spotid);
            // $spot.replaceWith('<div id='' + spotid + '' class='dart-ad'></div>');
            // adlog('adding', this.name, this.spotid);


            if (!this.name || (!ADSIZES[this.name] && !RESPONSIVE_AD_SIZES[this.name])) {
                adlog('WARN: failed adding', $block, this.name, ADSIZES[this.name], RESPONSIVE_AD_SIZES[this.name]);
                return false;
            }
            if (ADSIZES[this.name]) {
                this._buildSlot(ADSIZES[this.name], false);
            } else {
                this._buildSlot(RESPONSIVE_AD_SIZES[this.name], true);
            }

            return this;
        },

        _buildSlot: function (sizes, isResponsive) {
            var self = this;
            // Detect above-the-fold/below-the-fold state for an ad placeholder
            var aboveTheFoldState; // undefined initially
            var element = document.getElementById(this.spotid);
            // This applies to non-hidden elements only, which is defined as having non-empty getClientRects() set
            if (element && element.getClientRects().length) {
                var clientRect = element.getBoundingClientRect();
                // We assume that the top pixel of the element should be above the fold for the element to be considered "above the fold"
                // The element height is not defined yet, so we have no idea where would be its bottom
                aboveTheFoldState = clientRect.top < (window.innerHeight || document.documentElement.clientHeight);
            }
            __mtm_data.push({ tag : {
                tagCode: {
                    type: 'CODE',
                    lazy: {
                        scroll: 100, /* px */
                        poll: 500 /* this is not required if layout doesn't change */
                    },
                    data: function () {
                        var aSize;

                        if (isResponsive) {
                            aSize = sizes[0][1];
                        } else {
                            aSize = sizes;
                        }

                        googletag.cmd.push(function () {
                            if (self.supertag_override) {
                                // Updates ad zone in modules.  Data module must be set in .hbs file to work.
                                var base_path_array = self.base_path.split('/');
                                if (base_path_array[3] === 'homepage') {
                                    base_path_array[4] = self.supertag_override.replace(/-/g, '');
                                    self.base_path = base_path_array.join('/');
                                }
                            }

                            //set adzone to nsfw if the page is tagged as nsfw
                            if (App.Data.ads_model.ads.nsfw) {
                                var base_path_array = self.base_path.split('/');
                                base_path_array[3] = 'nsfw';
                                self.base_path = base_path_array.join('/');
                            }

                            var vport = (function() {
                                var window_width = window.innerWidth;
                                if (window_width >= 1024) {
                                    return 'l';
                                }
                                else if (window_width < 1024 && window_width >= 640) {
                                    return 'm';
                                }
                                else if (window_width < 640) {
                                    return 's';
                                }
                            })();

                            var s = googletag.defineSlot(self.base_path + '/' + self.name, aSize, self.spotid);
                            // Make sure event is emmited when flexiblepushdown is rendered
                            googletag.pubads().addEventListener('slotRenderEnded', function(event) {
                                // Emit event fc:flexleaderboardRendered when changes happen to flexleaderboard
                                if (self.name === 'flexiblepushdown') {
                                    $(window).trigger('fc:flexleaderboardRendered');
                                }
                                // send analytics info about the slot name
                                if (event.isEmpty) {
                                    trackAdLoadFail(event.slot.getAdUnitPath(), event.slot.getAdUnitPath());
                                }
                                var el = result.slot && result.slot.getSlotElementId();
                                el = el && document.getElementById(el);
                                // for empty divs, we have to manually collapse
                                // their wrapper (google only collapses its own div)
                                if (el) {
                                    var visible = !result.isEmpty;
                                    var container = $(el).closest('.ad-unit');
                                    container.css({
                                        display: (visible ? 'block' : 'none')
                                    });
                                }
                                adsLoaded.push(self.name);
                                self.$block.find('.ad-label').text('Advertisement');
                                $(window).trigger('fc:adsheightchanged');
                            });

                            if (isResponsive) {
                                s.defineSizeMapping(sizes);
                            }
                            self.slot = s.addService(googletag.pubads());

                            s.setTargeting('adslot', self.name);
                            s.setTargeting('vport', vport);

                            if (aboveTheFoldState !== undefined) {
                                s.setTargeting('pos', aboveTheFoldState ? 'atf' : 'btf');
                            }

                            if (self.name === 'flexiblepushdown' || self.name === 'fixedrectangle') {
                                slotsToRefreshInVideoChange.push(s);
                            }
                            /**
                             * This function is triggered when a message is sent when video changes
                             * It refreshes the above the nav and the rail ads
                             */
                            var refreshAdsOnVideoChange = function(event) {
                                if (event.data.name && event.data.name === 'playListNext') {
                                    googletag.pubads().refresh(slotsToRefreshInVideoChange);
                                }
                            };

                            if (window._refreshOnVideoChange) { // If enabled start listening
                                window.addEventListener('message', refreshAdsOnVideoChange, false);
                            }

                            googletag.display(self.spotid);
                            adlog('slot created, calling prep refresh');
                            self.prepRefresh();
                            // Stop slideshowrectangle from rendering on first slide, however, keep slot defined for refresh
                            if (isSlideshow && USER_EVENT_REFRESH_AD_HIDE && self.name === USER_EVENT_REFRESH_AD) {
                                var el = document.querySelector('[data-advertising="' + USER_EVENT_REFRESH_AD + '"]');
                                el.style.visibility = 'hidden';
                                return;
                            }
                            googletag.pubads().refresh([s]);
                        });
                    }
                },
                place: {
                    sel: '#' + self.spotid
                }
            } });
        },

        prepRefresh: function () {
            var self = this,
                ctime = dateNow();

            if (!self.slot || ctime - self.lastTime < WAITTIME) {
                adlog('returning without pushing slot', self.slot, ctime - self.lastTime, WAITTIME);
                return;
            }
            self.lastTime = dateNow();

            REFRESH_THESE.push(self.slot);

        },

        // break references to things
        remove: function () {
            if (this.slot) {
                this.slot.renderEnded = this.slot.oldRenderEnded;  // reset this back for gc
            }
            this.$block = null;
            this.base_path = null;
            this.slot = null;
            this.name = null;
            // this.$spot.empty();
            // this.$spot = null;
        }
    };

    var AdSlotOOP = function (base_path, spotid) {
        var self = this;
        this.spotid = spotid;
        this.slot = null;
        this.lastTime = 0;
        this.base_path = base_path;

        window.__mtm_data = window.__mtm_data || [];

        __mtm_data.push({ tag : {
            tagCode: {
                type: 'CODE',
                lazy: {
                    scroll: 100, /* px */
                    poll: 500 /* this is not required if layout doesn't change */
                },
                data: function () {
                    googletag.cmd.push(function () {
                        self.slot = googletag.defineOutOfPageSlot( self.base_path + '/oop', self.spotid).addService(googletag.pubads());
                        self.slot.setTargeting('adslot', 'oop');
                        googletag.display(self.spotid);
                        self.prepRefresh();
                        googletag.pubads().refresh([self.slot]);
                    });
                    return this;
                },
                place: {
                    sel: '#' + self.spotid
                }
            }
        } });
    };

    AdSlotOOP.prototype = {
        prepRefresh: function () {
            var self = this,
                ctime = dateNow();

            if (!self.slot || ctime - self.lastTime < WAITTIME) {
                return;
            }
            self.lastTime = dateNow();

            REFRESH_THESE.push(self.slot);
        },

        remove: function () {
            // noop?
        }
    };

    var AdManager = function () {

        if (!googletag) {
            // console.error('gpt not loaded');
            return;
        }

        this.init();
    };

    AdManager.prototype = {
        currentid: -1,
        model: null,
        ad_core: {},
        ad_params: {},
        base_path: '',
        slots: {},

        init: function () {
            var headerWrap = $('.header-wrap .ad-unit');
            var self = this;
            var model = App.Data.ads_model;

            // var model = {'id':'homepage','kind':'slate','type':'postList','name':'homepage','url':'http://www.m.fastcompany.com/homepage','site':{'name':'fastcompany.com','title':'Fast Company','url':'http://www.fastcompany.com','urlNoProtocol':'//www.fastcompany.com','slug':'fastcompany'},'ads':{'path':'/4160/mv.fc/homepage/homepage'}}

            if (!model) {
                // console.error('No model found in admanger');
            }

            googletag.cmd.push(function () {
                googletag.pubads().collapseEmptyDivs();
                googletag.pubads().disableInitialLoad();
                googletag.pubads().enableSingleRequest();
                googletag.pubads().enableAsyncRendering();
                googletag.pubads().setCentering();
                googletag.enableServices();
                googletag.pubads().setTargeting('ksg', Krux.segments);
                googletag.pubads().setTargeting('kuid', Krux.user);
            });

            self.renderAds(model);

        },

        renderSlideshowInterstitial: function($region) {
            this._makeNewSlot('mobile_interstitial', $region);
            this._doRefreshBatch();
        },

        renderAds: function (model) {
            this.model = model;
            var self = this,
                id = model.id;
            if (id === this.currentid) { // check so that the page doesn't reload its ads over and over again when clicking super fast.
                return;
            }
            this.currentid = id;
            // this.ad_core = model.get('ads');

            if (this.slots) {
                $.each(this.slots, function (item) {
                    item.remove();
                });
            }

            this.slots = {};

            var site = get(model, 'site.name');
            var adCodeMap = {
                'fastcompany.com': 'mv.fc',
                'fastcodesign.com': 'mv.fcdesign',
                'fastcoexist.com': 'mv.fcexist',
                'fastcocreate.com': 'mv.fccreate',
                'fastcolabs.com': 'mv.fclabs'
            };

            var ads = this.model.ads || { path: '/4160/' + adCodeMap[site] + '/misc/misc' };

            // if (this.ads ==  path:"/4160/" + adCodeMap[site] + "/misc/misc" && url  )

            if (!ads || !ads.path) {
                adlog('ERROR: no ads path', model);
                //return;
            }

            this.ads = ads;

            this.base_path = ads.path;

            this._determineCustomParams();

            this._updateTargeting();

            this._buildAddSlots();

            this._buildOOPSlot();
        },

        _buildAddSlots: function () {
            var self = this;

            $('[data-advertising]').each(function () {
                var $block = $(this);
                var name = $block.data('advertising');
                self._makeNewSlot(name, $block);
            });
        },

        _buildOOPSlot: function () {
            //adlog('building OOP');
            var name = 'oopspecial';

            var spot = $('#gpt-oop-slot');

            if (!spot.length) {
                $('body').append('<div id="gpt-oop-slot" data-advertising="oop"></div>');
            }

            if (!this[name]) {
                this[name] = new AdSlotOOP(this.base_path, 'gpt-oop-slot');
            } else {
                this[name].prepRefresh();
            }

        },

        _makeNewSlot: function (name, $container) {
            // we can't put an ad inside of nothingness
            // this can happen from silly vent triggers. i.e. people pages which have postlists with special templates.
            if (!$container.length) {
                return;
            }

            var slot;
            if (name !== 'oop') {

                // For dynamically loaded ads, if an ad is already loaded, do not render the same slot again
                if ($container.hasClass('ad-loaded')) {
                    return;
                }
                $container.addClass('ad-loaded');
                slot = new AdSlot(this.base_path, name, $container, this.ad_params);

                if (!slot) {
                    return;
                }

                // slot.setTargettings(this.ad_params);

                //            if (this.slots[name]) { //this ad already exists somehow, remove its references and let the gc delete it hopefully
                //                this.slots[name].remove();
                //            }
                adlog(slot);

                this.slots[name] = slot;
            } else {
                if (!this.ads.oop) {    //out of page slop found but don't actually want to deal with it.
                    return;
                }
                slot = new AdSlotOOP(this.base_path, $container);
            }

            //prepend ad slug to all ads EXCEPT the sponsored by logo
            if(slot.name !== 'flexiblelogo' && slot.name !== 'mobileleaderboard'){
                $container.prepend('<div class="ad-slug">Advertisement</div>');
            }

        },

        _doRefreshBatch: function () {
            if (!REFRESH_THESE.length) {
                adlog('no slots to refresh!');
                return;
            }
            adlog('pushing call to refresh whole batch');
            googletag.cmd.push(function () {
                adlog('calling refresh on all REFRESH_THESE', REFRESH_THESE);
                googletag.pubads().refresh(REFRESH_THESE);
                REFRESH_THESE = [];
            });
        },

        _updateTargeting: function (params_to_update) {

            var self = this;

            var params = self.ad_params;

            adlog('params_to_update', params_to_update);

            if (params_to_update) {
                $.each(params_to_update, function (param) {
                    googletag.cmd.push(function () {
                        googletag.pubads().setTargeting(param, '' + params[param]); // ug at string type conversion
                    });
                });
            }
            else {
                $.each(params, function (key, value) {
                    googletag.cmd.push(function () {
                        googletag.pubads().setTargeting(key, '' + value);
                    });
                });
            }
        },

        // build the targeting parameters for all ads on this page.
        _determineCustomParams: function () {
            var params = {},
                model = this.model,
                name = model.name,
                type = model.type,
                kind = model.kind,
                url = model.url,
                topic = model.topic,
                supertag = model.supertag,
                tags = model.tags,
                vocab = model.vocab,
                author = model.author,

                keywords = model.keywords;

            if (kind == undefined) {
                params.c_type = type;
            } else {
                params.c_type = kind || '';
            }

            params.cms = this._generateCMS(name, url);

            if (typeof Krux != "undefined") {
                params.ksg = Krux.segments || [];
                params.kuid = Krux.user || '';
            }

            params.chn = [];
            if (topic && topic.slug) {
                params.chn.push(topic.slug);
            }
            if (supertag && supertag.slug) {
                params.chn.push(supertag.slug);
            }

            //TAGS
            if (tags) {
                var tagslugs = [];
                $.each(tags, function (t) {
                    if (t.slug) {
                        tagslugs.push(t.slug);
                    }
                });

                if (tagslugs.length) {
                    params.tags = tagslugs;
                }
            }

            if (keywords && keywords.socialtags) {

                if (!params.tags) {
                    params.tags = [];
                }

                $.each(keywords.socialtags, function(keyword, index){
                    params.tags.push(keyword);
                });

                params.tags = $.unique(params.tags);
            }

            if (params.tags) {
                params.tags = $.unique(params.tags);
            }

            params.slide = (kind === 'slideshow') ? 1 : 0;
            if (kind === 'slideshow') {
                isSlideshow = true;
            }
            // if (util.get('fastcache')) {
            //     params.login = 'yes'; //(util.get('fastcache') ? 1 : 0);
            // }

            //VIDEO
            params.video = (kind === 'video') ? 'yes' : 'no';

            // If kind is watch set global object _refreshOnVideoChange in order to enable listening to messages
            if (kind === "watch") {
                window._refreshOnVideoChange = true;
            }

            //AUTHOR
            params.aut = ((author && author.name) ? String(author.name).toLowerCase().replace(/\s+/g, '') : '');

            //Switched page level nsfw key/value to adzone
            // params.nsfw = this.ads.nsfw ? 'yes' : 'no';

            // Key val identifier for ad request coming into redesign
            params.abgroup = '1';

            this._overrideCustomParams(params);

            this.ad_params = params;
        },

        _overrideCustomParams: function (params) {

            // TODO: update docs
            // This function implements the ability to overwrite properties of ad calls
            // Documentation: https://github.com/fastcompany/docs/wiki/Use-AdZone-Override-feature-on-FastCompany-%28Jetpack%29
            // An example: http://localhost:8880/3003457/hey-nokia-time-another-pivot?base_path=/4160/mc.fc/homepoage&c_type=testctype&aut=yongzhihuang&chn=this,is,multiple,channels

            var overrideParams = 'chn,c_type,cms,ksg,video,login,aut,tags,slide,vport'.split(',');

            var query_string_array = window.location.search.substr(1).split('&');
            if (query_string_array.length === 0) {
                return;
            }

            var adzone_qa = this;

            $.each(query_string_array, function (index, value) {
                var query_string = value.split('=');
                var query_string_key = query_string[0];
                var query_string_value = query_string[1];

                if ( $.inArray( query_string_key, overrideParams) > -1 ) {
                    params[query_string_key] = query_string_value;
                }

                if ( query_string_key === 'adzone' ) {
                    var base_path_array = adzone_qa.base_path.split('/');
                    base_path_array[3] = query_string_value;
                    adzone_qa.base_path = base_path_array.join('/');
                }
            });

            // if (queryString.ad_change) {
            //     var ad_change_string = queryString.ad_change.split(',');

            //     for (var i = 0, len = ad_change_string.length; i < len; i++) {
            //         if (ADSIZES[ad_change_string[i]]) { // check if the name exists
            //             ADSIZES[ad_change_string[i]] = ad_change_string[i + 1].split('x');
            //         }
            //         i++;
            //     }

            // }
        },

        _generateCMS: function (name, url) {
            var key, hash = 0,
                i, chr;
            if (name === 'homepage' || name === 'technology' || name === 'leadership') {
                key = window.location.href;
            } else {
                key = url;
            }
            if (!key || key.length === 0) {
                return hash;
            }
            for (i = 0; i < key.length; i++) {
                chr = key.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash = hash & hash; // Convert to 32bit integer
            }
            hash = Math.abs(hash);
            hash = hash.toString(36);
            return hash;
        },

        _performUserEventRefresh: function () {
            this._userEventRefreshCounter = 0;
            // make sure slideshow rectangle is visible
            var rec = document.querySelector('[data-advertising="' + USER_EVENT_REFRESH_AD + '"]');
            if (rec) {
                rec.style.visibility = 'visible';
                var adSlot = this.slots[USER_EVENT_REFRESH_AD];
                // remove flexibleportrait on refresh
                if (USER_EVENT_REFRESH_AD_HIDE) {
                    var el = document.querySelector('[data-advertising="' + USER_EVENT_REFRESH_AD_HIDE + '"]');
                    if (el) {
                        el.remove();
                    }
                }
                // refresh normally
                if (adSlot && adSlot.slot) {
                    googletag.display(USER_EVENT_REFRESH_AD);
                    googletag.pubads().refresh([ adSlot.slot ]);
                }
            }
        },

        _userEventRefreshCounter: 0,
        _userEventRefreshHandlerId: 0,

        triggerUserEventRefresh: function () {
            if (USER_EVENT_REFRESH_COUNT && USER_EVENT_REFRESH_AD) {
                if (!this._userEventRefreshCounter) {
                    var self = this;
                    this._userEventRefreshHandlerId = setTimeout(function () {
                        self._userEventRefreshHandlerId = 0;
                        if (self._userEventRefreshCounter >= USER_EVENT_REFRESH_COUNT) {
                            // If the counter has overflown, perform refresh on timeout
                            self._performUserEventRefresh();
                        }
                    }, USER_EVENT_REFRESH_DEBOUNCE_PERIOD);
                }
                this._userEventRefreshCounter++;
                if (this._userEventRefreshCounter >= USER_EVENT_REFRESH_COUNT && !this._userEventRefreshHandlerId) {
                    // The timer expired without firing the refresh, do it ourselves
                    this._performUserEventRefresh();
                }
            }
        }
    };

    function uniqueId(prefix) {
        prefix = prefix || '';
        var num = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        return prefix + num;
    }

    return new AdManager();

}

var adManager;

function ad() {

    if (!adManager) {
        adManager = adManagerFactory();
    } else {
        return adManagerFactory();
    }

    return adManager;
}
/*eslint-enable */

module.exports = ad;
